<template>
	<div class="row">
	    <div class="col-md-12 mb-3">
	        <label for="corporacion">Corporación:</label>
	        <catalogo-corporaciones 
	            id="corporacion"
	            name="corporacion"
	            v-model="data.corporacion">
	        </catalogo-corporaciones>
	    </div>

	    <div class="col-md-12 mb-3">
	        <label>Cliente:</label>
	        <catalogo-clientes 
	            id="cliente"
	            name="cliente"
	            v-model="data.cliente"
	            :corporacion="data.corporacion">
	        </catalogo-clientes>
	    </div>

	    <div class="col-md-12 mb-3">
	        <label>Grupo Producto:</label>
	        <catalogo-grupo-productos 
	            id="grupo"
	            name="grupo"
	            v-model="data.grupo">
	        </catalogo-grupo-productos>
	    </div>

	    <div class="col-md-12 mb-3">
	        <label>Póliza:</label>
	        <catalogos-polizas 
	            id="polizas"
	            name="polizas[]"
	            v-model="data.polizas"
	            :cliente="data.cliente"
	            :multiple="'multiple'">
	        </catalogos-polizas>
	    </div>
	</div>
</template>
<script>
	export default {
		props: ['corporacion', 'cliente', 'grupo', 'polizas'],

		data() {
			return {
				data: {
					corporacion: '',
					cliente: '', 
					grupo: '', 
					polizas: ''
				}
			}
		},

		watch: {
			corporacion: function(val){
				this.data.corporacion = val
				this.data.cliente = ''
				this.data.polizas = ''
			},

			cliente: function(val){
				this.data.cliente = val
				this.data.polizas = ''
			},

			grupo: function(val){
				this.data.grupo = val
			},

			polizas: function(val){
				this.data.polizas = val
			},
		}
	}
</script>